<template>
    <HeroSection :featureName="baseFeature.name" :icon="baseFeature.icon">
        <template #title>{{ baseFeature.description }}</template>
        <template #description>
            <div>Allow Attendees to scan badges to make connections, send messages and schedule meetings with other attendees and exhibitors.</div>
            <div class="mt-4">Create meeting blocks and enable structured sessions to maximize time.</div>
        </template>
        <template #content>
            <div class="w-full relative h-[500px]">
                <div class="absolute top-0 left-0 w-1/2 h-full" >
                    <DeviceWrapper deviceType="phone" :width="80" :z="0" :x="0" :y="12" :rotateOnScroll="true" :imageSrc="eventAppImage" />
                </div>

                <div class="absolute top-0 right-12 w-1/2 h-full" >
                    <DeviceWrapper deviceType="phone" :width="80" :z="0" :x="0" :y="-16" :rotateOnScroll="true" :imageSrc="eventAppImage2" />
                </div>

                <div v-reveal class="absolute bottom-0 right-0 w-64 h-64 ">
                    <img :src="megaphone" alt="Badge" class="w-full h-full object-contain" />
                </div>
            </div>
        </template>
    </HeroSection>

    <Tips :title="baseFeature.name" :tips="tips" />
    <WorksWith :title="baseFeature.name" :integrations="integrations" />
    <Cta />
</template>

<script setup>
import Cta from '../../components/Blocks/Cta.vue';
import HeroSection from '../../components/HeroSection.vue';
import CmsAndApp from '../../components/Layouts/CmsAndApp.vue';
import Tips from '../../components/Blocks/Tips.vue';
import DeviceWrapper from '@/components/DeviceWrapper.vue';
import WorksWith from '../../components/Blocks/WorksWith.vue';
import { getFeaturesByIds } from '../../router/features';

import eventAppImage from '@/images/screenshots/app/theme-1/profile-meeting.png';
import eventAppImage2 from '@/images/screenshots/app/theme-1/meetings.png';

import megaphone from '@/images/megaphone.svg';

const tips = [
    'Consider the time it takes to move between meetings and sessions. Add a small gap between meetings to allow for this.',
    'Profile Types define a range of networking permissions, including who is visible in the Attendee List and who can join meetings.'
];

const baseFeature = getFeaturesByIds(['meetingsandnetworking'])[0];
const integrations = getFeaturesByIds(['eventapp', 'leadcapture', 'companyportals']);
</script>
